import { useEffect } from "react";
import { debounce } from "../utils/debounce.js";
const useLayoutEvent = (callback, events = ["layoutchange", "resize", "orientationchange"], debounceMs = 10) => {
  useEffect(() => {
    if (typeof window !== "object") return;
    const [debouncedCallback, teardown] = debounce(callback, debounceMs);
    events.forEach((eventName) => window.addEventListener(eventName, debouncedCallback));
    debouncedCallback();
    return () => {
      teardown();
      events.forEach((eventName) => window.removeEventListener(eventName, debouncedCallback));
    };
  }, []);
};
export {
  useLayoutEvent
};
//# sourceMappingURL=useLayoutEvent.js.map
